import { t } from "i18next";

const rankIconMap = {
    Admin: 'fa-solid fa-screwdriver-wrench',
    Bot: 'fa-solid fa-robot',
    Reviewer: 'fa-solid fa-star-half-stroke',
    Verified: 'fa-solid fa-circle-check'
}

export function displayUserRanks(user, container, tooltip = 'bottom') {
    container.classList.add('flex', 'gap-1', 'items-center');
    container.innerHTML = '';
    
    container.append(createUserBadges(user, tooltip));
}

export function createUserBadges(user, tooltip = 'bottom') {
    const badges = getUserRanks(user);

    if (!badges) {
        return;
    }

    return badges.map(badge => {
        const badgeElement = document.createElement('span');
        badgeElement.classList.add('badge', 'badge-sm', 'badge-outline', 'mr-1');
        badgeElement.setAttribute('data-tooltip', t(`tags.${badge}`));
        badgeElement.setAttribute('data-tooltip-position', tooltip);
        badgeElement.innerHTML = `<i class="fa-solid fa-award"></i> ${t(`tags.${badge}`)}`;
        return badgeElement;
    });
}

export function getUserRanks(user) {
    const ranks = [];

    if (!user || !user.types || !user.types.length) {
        console.error('Invalid user data, no available ranks:', user);
        return;
    }
    if (user.types.includes('Admin')) {
        ranks.push(t('tags.admin'));
    }
    if (user.types.includes('Bot')) {
        ranks.push(t('tags.bot'));
    }
    if (user.types.includes('Reviewer')) {
        ranks.push(t('tags.reviewer'));
    }
    if (user.verified) {
        ranks.push(t('tags.verified'));
    }

    return ranks;
}

export function getUserBadges(user) {
    const badges = getUserBadges(user);

    if (!badges) {
        return;
    }

    // Rating Count Badges
    if (user.ratingsCount > 50) {
        badges.push(t('tags.critic'));
    } else if (user.ratingsCount > 30) {
        badges.push(t('tags.pioneer'));
    } else if (user.ratingsCount > 15) {
        badges.push(t('tags.explorer'));
    }

    // Review Count Badges
    if (user.reviewsCount > 100) {
        badges.push(t('tags.legend'));
    } else if (user.reviewsCount > 50) {
        badges.push(t('tags.hero'));
    } else if (user.reviewsCount > 30) {
        badges.push(t('tags.expert'));
    } else if (user.reviewsCount > 15) {
        badges.push(t('tags.helper'));
    }

    // Monthly Rank Badge
    if (user.monthlyRank && user.monthlyRank > 0 &&  user.monthlyRank <= 3) {
        badges.push(t('tags.monthlyChamp'));
    }

    if (user.totalPoints > 500 || user.monthlyPoints > 50) {
        badges.push(t('tags.topContributor'));
    }

    // Total Points Badge
    if (user.totalPoints > 50) {
        badges.push(t('tags.collector'));
    }

    // Monthly Points Badge
    if (user.monthlyPoints > 15) {
        badges.push(t('tags.risingStar'));
    }
}

export function displayStatus(element, status) {
    if (!element || !status) {
        console.error('Invalid element or status:', element, status);
        return;
    }

    if (status == 'online') {
        element.classList.add('text-success');
        element.innerHTML = `<i class="fa-solid fa-circle text-success"></i> ${t('profile.online')}`;
    } else if (status == 'offline') {
        element.classList.add('text-error');
        element.innerHTML = `<i class="fa-solid fa-circle text-error"></i> ${t('profile.offline')}`;
    } else if (status == 'busy') {
        element.classList.add('text-warning');
        element.innerHTML = `<i class="fa-solid fa-circle text-warning"></i> ${t('profile.busy')}`;
    } else if (status == 'away') {
        element.classList.add('text-warning');
        element.innerHTML = `<i class="fa-solid fa-circle text-warning"></i> ${t('profile.away')}`;
    } else if (status == 'invisible') {
        element.classList.add('text-secondary');
        element.innerHTML = `<i class="fa-solid fa-circle text-secondary"></i> ${t('profile.invisible')}`;
    } else {
        console.error('Unknown status:', status);
    }
}

export function isUserLoggedIn() {
    if (alertUser) {
        return true;
    }
    return false;
}

export function isFriend(user) {
    const userId = typeof user === 'object' ? user.id : user;

    if (!userId || isNaN(userId)) {
        return false;
    }

    const id = parseInt(userId);

    if (!isUserLoggedIn()) {
        return false;
    }
    if (alertUser.friends && alertUser.friends.length && alertUser.friends.length > 0) {
        return alertUser.friends.includes(id);
    }

    return false;
}